var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCirlce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close-Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close-Circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round",
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1213,
    y1: 9.87866,
    x2: 9.8787,
    y2: 14.1213,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.87866,
    y1: 9.87866,
    x2: 14.1213,
    y2: 14.1213,
    id: "Path",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCirlce);
export default __webpack_public_path__ + "static/media/close-cirlce.af122b1f533b9dfb7ae219b3c8323591.svg";
export { ForwardRef as ReactComponent };